import { Tooltip } from '@/components/primitives/Tooltip'

import { Row } from '../../Row'

import { useTexts } from '../useTexts'

interface Props {
  count: number
  onSelect: () => void
}

export function OrdersToDo(props: Props) {
  const { count, onSelect } = props
  const texts = useTexts()

  return (
    <Tooltip
      textAlign="left"
      placement="right"
      title={texts.ordersToDo}
      subtitle={texts.ordersToDoTooltip}
    >
      <Row
        onClick={onSelect}
        text={texts.ordersToDo}
        value={count}
        disabled={count === 0}
        testId="plan-summary-todo-orders"
      />
    </Tooltip>
  )
}
